
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStopped as ObiStoppedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-stopped.js';
 
 
 

 
 export const ObiStopped = createComponent({
   react: React,
   tagName: 'obi-stopped',
   elementClass: ObiStoppedElement,
   events: {
     
   }
  });
 
 